export const BASE_OTT_DIMENSIONS = ['cross_device_ott', 'ott'] as const;
export const INSTALL_COHORT_OTT_DIMENSIONS = ['install_activity_ott', 'install_activity_cross_device_ott'] as const;
export const REENGAGEMENT_OTT_DIMENSIONS = ['reengagement_activity_ott', 'reengagement_activity_cross_device_ott'] as const;

export const ALL_OTT_DIMENSIONS = [...BASE_OTT_DIMENSIONS, ...INSTALL_COHORT_OTT_DIMENSIONS, ...REENGAGEMENT_OTT_DIMENSIONS];
